import { useQuery } from "@tanstack/react-query";
import { fetchSinirCredentialStatus } from "@/integrations/mtrManager/client";
import { useAuthContext } from "@/components/AuthProvider";

/**
 * Consulta se o gerador (usuário externo) atual possui ao menos uma
 * credencial ativa do órgão Sinir. Usado pelo pop-up de aviso (GR-564).
 * Só executa para usuários externos com profile já carregado.
 */
export function useSinirCredentialStatus() {
  const { profile } = useAuthContext();

  const { data, isError, isLoading } = useQuery({
    queryKey: ["sinir-credential-status"],
    queryFn: () => fetchSinirCredentialStatus(),
    enabled: !!profile && profile.is_internal === false,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  return {
    hasActiveCredential: data?.has_active_credential ?? false,
    isError,
    isLoading,
  };
}
